module.exports = __webpack_public_path__ + "static/media/optionPlus.0d59f0da.svg";